import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import { BrowserRouter } from "react-router-dom";
import RoutesList from "./routes/Routes";
import "./App.css";
// import SearchInput from "./components/search/SearchInput";
// import DataTable from "./components/DataTable/DataTable";
// import DashboardLayout from "./components/dashboardLayout/DashboardLayout";
import bootstrap from "bootstrap/dist/js/bootstrap.bundle.min";

function App() {
  const tooltipTriggerList = document.querySelectorAll(
    '[data-bs-toggle="tooltip"]',
  );
  const tooltipList = [...tooltipTriggerList].map(
    (tooltipTriggerEl) => new bootstrap.Tooltip(tooltipTriggerEl),
  );
  return (
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <div className="App text-secondary">
        <Header />
        <RoutesList />

        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
